<template>
    <div id="app" class="page-wrapper">

        <!-- Preloader -->
        <div class="preloader"></div>

        <router-view />


        <!--Info Section-->
        <section class="info-section">
            <div class="auto-container">
                <div class="inner-section">
                    <div class="row clearfix">

                        <!--Info Block-->
                        <div class="info-block col-md-4 col-sm-6 col-xs-12">
                            <div class="inner">
                                <div class="content">
                                    <div class="icon-box"><span class="icon flaticon-maps-and-flags"></span></div>
                                    <div class="title">{{ $t('common.address') }} :</div>
                                    <h2>B-COM, s.a.s <br/>6 rue de Coulanges, 94370 Sucy-en-Brie, FRANCE</h2>
                                </div>
                            </div>
                        </div>

                        <!--Info Block-->
                        <div class="info-block col-md-4 col-sm-6 col-xs-12">
                            <div class="inner">
                                <div class="content">
                                    <div class="icon-box"><span class="icon flaticon-e-mail-envelope"></span></div>
                                    <div class="title">Email :</div>
                                    <h2>contact@bcom.eu</h2>
                                </div>
                            </div>
                        </div>

                        <!--Info Block-->
                        <div class="info-block col-md-4 col-sm-12 col-xs-12">
                            <div class="inner">
                                <div class="content">
                                    <div class="icon-box"><span class="icon flaticon-chronometer-outline"></span></div>
                                    <div class="title">{{ $t('common.open-hours-label') }} :</div>
                                    <h2>{{ $t('common.open-hours-value') }}</h2>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <!--End Info Section-->

        <!--Main Footer-->
        <footer class="main-footer">

            <!--Widgets Section-->
            <div class="widgets-section">
                <div class="auto-container">
                    <div class="row clearfix">

                        <!--Footer Column-->
                        <div class="footer-column col-md-4 col-sm-5 col-xs-12">
                            <!--Logo Widget-->
                            <div class="footer-widget logo-widget">
                                <div class="widget-content">
                                    <div class="footer-logo">
                                        <a href="/"><img src="images/footer-logo-bcom.png" alt="" /></a>
                                    </div>
                                    <div class="text">
                                        <p>Copyright &copy; B-COM {{nowYear}} | All Right Reserved</p>

                                        <ul class="footer-links">
                                            <li><router-link to="/privacy-policy">Privacy</router-link></li>
                                        </ul>
                                    </div>
                                    <!--ul class="social-icon-one">
                                        <li><a href="#"><span class="fa fa-facebook-f"></span></a></li>
                                        <li><a href="#"><span class="fa fa-twitter"></span></a></li>
                                        <li><a href="#"><span class="fa fa-skype"></span></a></li>
                                        <li><a href="#"><span class="fa fa-linkedin"></span></a></li>
                                    </ul-->
                                </div>
                            </div>
                        </div>

                        <!--Footer Column-->
                        <div class="footer-column col-md-4 col-sm-7 col-xs-12">
                        </div>

                        <!--Footer Column-->
                        <div class="footer-column col-md-4 col-sm-12 col-xs-12">
                            <!--Form Widget-->
                            <div class="footer-widget form-widget">
                                <h2>{{ $t('common.footer-form.request-quote') }}</h2>
                                <div class="widget-content">

                                    <div class="newsletter-form">
                                        <div>
                                            <div class="row clearfix">
                                                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                    <input type="text" name="name" value="" :placeholder="$t('common.footer-form.your-name')" required="" v-model="messageName">
                                                </div>
                                                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                    <input type="email" name="email" value="" :placeholder="$t('common.footer-form.email')" required="" v-model="messageEmail">
                                                </div>
                                                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                    <input type="text" name="number" value="" :placeholder="$t('common.footer-form.phone')" required="" v-model="messagePhone">
                                                </div>
                                                <div class="form-group col-md-6 col-sm-6 col-xs-12">
                                                    <input type="text" name="text" value="" :placeholder="$t('common.footer-form.company')" required="" v-model="messageCompany">
                                                </div>
                                                <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                    <textarea placeholder="Message" v-model="messageText"></textarea>
                                                </div>
                                                <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                                    <button class="theme-btn btn-style-one" href="#" type="button" v-on:click="sendMessage()">
                                                        <span v-if="sendMessageLoading" class="spinner-border text-light mt-3" role="status"></span>
                                                        <div v-if="sendMessageLoading">Please wait ...</div>
                                                        <div v-if="!sendMessageLoading">{{ $t('common.footer-form.submit') }}</div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </footer>
        <!--End Main Footer-->


        <div class="modal"  id="sendMessageModal" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 v-if="messageSent" class="modal-title">Thank you</h5>
                <h5 v-if="!messageSent" class="modal-title">Service not available</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p v-if="messageSent">Thank you for your message, we will get back to you soon</p>
                <p v-if="!messageSent">An error has occurred. Please try again or contact us at contact@bcom.eu</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>


    </div>
    <!--End pagewrapper-->

</template>

<script>
import EmailService from './services/email.service';

export default {
  data() {
    return {
      messageName: '',
      messageEmail: '',
      messagePhone: '',
      messageCompany: '',
      messageSubject: 'Message',
      messageText: '',

      sendMessageLoading: false,

      messageSent: true,
      nowYear: '',
    };
  },
  computed: {

    currentPa() {
      return this.$router.history.current.name;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },

    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MODERATOR');
      }

      return false;
    }
  },
  mounted() {

    const d = new Date();
    this.nowYear = d.getFullYear();

    this.$root.$on('send-message', (msg) => {
      this.messageSent = (msg === 'success');
      $('#sendMessageModal').modal('show');
    });

  },
  methods: {
    sendMessage() {
      this.sendMessageLoading = true;
      EmailService.send(this.messageName, this.messageEmail, this.messageSubject, this.messagePhone, this.messageCompany, this.messageText).then(
        response => {
          this.sendMessageLoading = false;
          this.$root.$emit("send-message", "success");
        },
        error => {
          this.sendMessageLoading = false;
          this.$root.$emit("send-message", "failure");
        }
      );
    }
  }
};
</script>